import { z } from 'zod'

import type { ZodInfer } from '@mntn-dev/utility-types'

import { ChargeKindSchema } from '../billing/charge-kind.ts'
import { LogLevels } from '../logger/log-levels.models.ts'
import { BidIdSchema, ProjectIdSchema } from '../unique-id.models.ts'

export const GetProjectFinanceBreakdownInputSchema = z.object({
  projectId: ProjectIdSchema,
  chargeKind: ChargeKindSchema,
  bidId: BidIdSchema.optional(),
  withMargin: z.boolean().optional(),
  defaultBid: z.boolean().optional(),
  defaultBillingMethod: z.boolean().optional(),
  zeroAlreadyPaid: z.boolean().optional(),
  errorSeverity: z.enum(LogLevels).optional(),
})

export type GetProjectFinanceBreakdownInput = ZodInfer<
  typeof GetProjectFinanceBreakdownInputSchema
>
